import { debounceTime, switchMap, takeUntil, skip } from "rxjs/operators";

export class AutoComplete  {
  static autocomplete = (time, selector) => (source$) =>
  source$.pipe(
    debounceTime(time),
    switchMap((...args: any[]) => 
      selector(...args)
        .pipe(
            takeUntil(
                source$
                    .pipe(
                        skip(1)
                    )
            )
        )
    )
  )
                    }